export default __webpack_public_path__ + "static/media/check.cb05f640.svg";